export const AUTH_API_KEYS = {
  ACCESS_TOKEN: "access_token",
  TWO_FACTOR_REQUIRED: "two_factor_required",
  MISSING_CELLPHONE: "missing_cell_phone_number",
  FIRST_SIGN_IN: "first_sign_in",
  GRANT_TYPE_PASSWORD: "password",
  GRANT_TYPE_REFRESH_TOKEN: "refresh_token",
  SCOPE: "employee",
} as const;
